import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=ecd9e8f8"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports